var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVirtualVisit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70377 6.27482C9.70377 6.70482 9.78843 7.13062 9.95293 7.5279C10.1174 7.92517 10.3585 8.28614 10.6625 8.5902C10.9665 8.89427 11.3273 9.13546 11.7245 9.30002C12.1216 9.46457 12.5473 9.54927 12.9771 9.54927C13.407 9.54927 13.8326 9.46457 14.2298 9.30002C14.6269 9.13546 14.9878 8.89427 15.2917 8.5902C15.5957 8.28614 15.8368 7.92517 16.0013 7.5279C16.1658 7.13062 16.2505 6.70482 16.2505 6.27482C16.2505 5.40638 15.9056 4.57351 15.2917 3.95943C14.6779 3.34535 13.8453 3.00037 12.9771 3.00037C12.109 3.00037 11.2764 3.34535 10.6625 3.95943C10.0486 4.57351 9.70377 5.40638 9.70377 6.27482Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4474 12.4397C20.1598 12.9924 21.9765 14.056 21.9765 15.2787C21.9765 16.8782 18.8036 18.2181 14.6093 18.4945",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50552 12.4397C5.79308 12.9924 3.97641 14.056 3.97641 15.2787C3.97641 16.9536 7.55951 18.3856 12.1389 18.5364",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7037 16.093L12.1566 18.5468L9.7037 21.0005",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8822 15.2749V14.4375C17.8778 13.1388 17.359 11.8949 16.4394 10.9782C15.5199 10.0615 14.2746 9.54671 12.9764 9.54672C11.6753 9.54672 10.4274 10.0638 9.50741 10.9841C8.58739 11.9044 8.07053 13.1527 8.07053 14.4542V15.2917",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualVisit);
export default __webpack_public_path__ + "static/media/virtualVisit.f5ce02c35ab2b0e9a4aea006e1f75100.svg";
export { ForwardRef as ReactComponent };